<template>
    <v-container grid-list-xl>
        <v-layout row wrap>
            <v-flex xs6>
                <h1>Staff</h1>
            </v-flex>
            <v-flex xs6 class="text-right">
                <v-btn color="primary" depressed dark @click="createUserCallback()">Add Staff</v-btn>
                <v-btn color="neutral ml-2" dark :to="'/management/staff/archived'">Archived</v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="users"
                        item-key="name"
                        class="elevation-1">
                        <template v-slot:item.action="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                        <v-icon
                                            v-on="on"
                                            class="mr-1"
                                            color="orange"
                                            @click="updateDialogForUser(item)">
                                            mdi-square-edit-outline
                                        </v-icon>
                                </template>
                                <span>Edit User</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-1"
                                        color="grey"
                                        @click="archiveDialogForUser(item)">
                                        mdi-archive
                                    </v-icon>
                                </template>
                                <span>Archive User</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        color="primary"
                                        @click="passwordReset(item)">
                                        mdi-lock-reset
                                    </v-icon>
                                </template>
                                <span>Reset Password</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <add-user
            :showDialog="createUserDialog"
            :toggle="toggleCreate">
        </add-user>

        <update-user
            :showDialog="updateUserDialog"
            :toggle="toggleUpdate"
            :userDetails="userToUpdate"
            :userRole="userRole">
        </update-user>

        <archive-user
            :showDialog="archiveUserDialog"
            :toggle="toggleArchive"
            :user="userArchive">
        </archive-user>

        <password-reset
            :showDialog="passwordDialog"
            :toggle="togglePassword"
            :user="userToUpdate">
        </password-reset>
    </v-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import AddUser from '@/components/users/Add'
    import UpdateUser from '@/components/users/Update'
    import ArchiveUser from '@/components/users/Archive'
    import PasswordReset from '@/components/users/ResetPassword'
    export default {
        name: 'listStaff',
        components: {
            AddUser,
            UpdateUser,
            ArchiveUser,
            PasswordReset
        },
        created () {
            this.loadAllUsers()
            this.loadRoles()
        },
        data () {
            return {

                archiveUserDialog: false,
                updateUserDialog: false,
                createUserDialog: false,
                passwordDialog: false,
                userArchive: null,
                userRole: null,
                index: null,
                userToUpdate: {},
            }
        },

        methods: {
            ...mapActions({
                loadAllUsers: 'user/loadAllUsers',
                loadRoles: 'role/loadRoles',
                createUser: 'user/createUser',
                clearAccount: 'account/clearAccount'
            }),
            createUserCallback() {
                this.createUserDialog = true;
            },
            toggleCreate () {
                this.createUserDialog = !(this.createUserDialog)
            },
            toggleUpdate () {
                this.updateUserDialog = !(this.updateUserDialog)
            },
            toggleArchive () {
                this.archiveUserDialog = !(this.archiveUserDialog)
            },
            togglePassword () {
                this.passwordDialog = !(this.passwordDialog)
            },
            archiveDialogForUser (item) {
                this.userArchive = item.user
                this.toggleArchive()
            },
            updateDialogForUser (item) {
                this.userToUpdate = item.user
                this.userRole = item.user.roles[0]
                this.toggleUpdate()
            },
            passwordReset (item) {
                this.userToUpdate = item.user
                this.clearAccount()
                item.user.password = ''
                item.user.confirm = ''
                this.togglePassword()
            }
        },
        computed: {
            ...mapGetters({
                users: 'user/users',
                headers: 'user/headers',
                error: 'user/error'
            }),

        }
    }
</script>
